export const flatBottomBagSupportsSidePanelArtwork = false;
